import { createSlice } from "@reduxjs/toolkit";
import { getWorkflowInfo } from "api/formDisplay";

const initialState = {
  activeSection: 1,
  activeGroup: 1,
  activeGroupName: "",
  maxActiveGroup: "",
  maxActiveSection: "",
  userDetail: {},
  primaryUser: {},
  workflowUser: {},
  loading: false,
  error: "",
  applicantUser: {},
  subId: "",
  digilockerVerified: false

};

export const userInfo = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setUserDetail: (state, action) => {
      state.userDetail = { ...state.userDetail, ...action.payload };
    },
    setworkflowUser: (state, action) => {
      state.workflowUser = action.payload;
    },
    setPrimaryUser: (state, action) => {
      state.primaryUser = action.payload;
    },
    clearUserDetail: (state) => {
      state.userDetail = {};
    },
    changeActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    changeActiveGroup: (state, action) => {
      state.activeGroup = action.payload;
    },
    changeMaxActiveGroup: (state, action) => {
      state.maxActiveGroup = action.payload;
    },
    changeMaxActiveSection: (state, action) => {
      state.maxActiveSection = action.payload;
    },
    setApplicantUser: (state, action) => {
      state.applicantUser = action.payload;
      state.activeSection = action.payload?.active_section;
      state.activeGroup = action.payload?.active_group;
      state.maxActiveSection = action.payload?.max_active_section;
      state.maxActiveGroup = action.payload?.max_active_group;
      if (
        action.payload?.active_section === undefined ||
        action.payload?.active_group === undefined
      ) {
        state.activeSection = state.activeSection || 1;
        state.activeGroup = state.activeGroup || 1;
        state.maxActiveSection = state.maxActiveGroup || 1;
        state.maxActiveGroup = state.maxActiveGroup || 1;
      }
      state.userDetail = { ...state.userDetail, ...action.payload };
    },
    setSubId: (state, action) => {
      state.subId = action.payload;
    },
    setActiveGroupName: (state, action) => {
      state.activeGroupName = action.payload;
    },
    changeDigilockerVerified: (state, action) => {
      state.digilockerVerified = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWorkflowInfo.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getWorkflowInfo.fulfilled, (state, action) => {
        state.activeSection = action.payload?.source_data?.active_section;
        state.activeGroup = action.payload?.source_data?.active_group;
        state.maxActiveSection = action.payload?.source_data?.max_active_section;
        state.maxActiveGroup = action.payload?.source_data?.max_active_group;
        if (
          action.payload?.source_data?.active_section === undefined ||
          action.payload?.source_data?.active_group === undefined
        ) {
          state.activeSection = 1;
          state.activeGroup = 1;
          state.maxActiveSection = 1;
          state.maxActiveGroup = 1;
        }
        state.userDetail = action.payload;
        state.applicantUser  = action.payload?.source_data?.subworkflows?.find(
          (item) => item.user_id === action?.payload?.user_id
        );
        state.error = "success";
        state.loading = false;
      })
      .addCase(getWorkflowInfo.rejected, (state, action) => {
        state.error = "rejected";
        state.loading = false;
      });
  },
});

export const {
  setUserDetail,
  setPrimaryUser,
  setworkflowUser,
  clearUserDetail,
  changeActiveSection,
  changeActiveGroup,
  changeMaxStep,
  changeMaxActiveGroup,
  changeMaxActiveSection,
  setApplicantUser,
  setSubId,
  setActiveGroupName,
  changeDigilockerVerified
} = userInfo.actions;

export default userInfo.reducer;
